'use strict';

/**
 * Предоставляет инструменты для работы с Агентом веб-доступа.
 * Например, запустить или отключить Агент веб-доступа.
 *
 * @namespace WebAccess.agent
 * @since 5.0.0.4100
 */

(function (global) {
  var Agent = global.agentCore.Agent.extend({
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Проверяет, включен ли запрет на использование и запуск Агента веб-доступа.
     *
     * @method WebAccess.agent.isDisabled
     * @return {boolean} True – запрет на использование и запуск Агент веб-доступа включен, иначе False.
     * @since 5.1.0.1511
     */
    isDisabled: function () {
      var isDisabledValue = WA.cache.getItem('agent.isDisabled');
      $.cookie('IsAgentDisabled', isDisabledValue, { expires: 3650 });
      return isDisabledValue === '1';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Включает запрет на использование и запуск Агента веб-доступа.
     *
     * @method WebAccess.agent.disable
     * @return {WebAccess.agent} Объект типа agent.
     * @since 5.1.0.1511
     */
    disable: function () {
      log.warning('AGENT', 'Agent was manualy disabled');
      WA.cache.setItem('agent.isDisabled', '1');
      $.cookie('IsAgentDisabled', '1', { expires: 3650 });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отключает запрет на использование и запуск Агента веб-доступа.
     *
     * @method WebAccess.agent.enable
     * @return {WebAccess.agent} Объект типа agent.
     * @since 5.1.0.1511
     */
    enable: function () {
      log.info('AGENT', 'Agent was manualy enabled');
      WA.cache.setItem('agent.isDisabled', '0');
      $.cookie('IsAgentDisabled', '0', { expires: 3650 });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Определяет, сохранено ли в кэше значение о запрете на использование и запуск Агента веб-доступа.
     *
     * @method WebAccess.agent.isDisableSetted
     * @return {boolean} True – значение в кэше сохранено, иначе False.
     * @since 5.4.0.1037
     */
    isDisableSetted: function () {
      return WA.cache.getItem('agent.isDisabled') !== null;
    },

    /**
     * @override
     * @see agentCore.Agent.isAvailable
     */
    isAvailable: function () {
      return this.canUseInCurrentDevice() && !this.isDisabled();
    },

    /**
    * Проверяет, доступен ли Агент веб-доступа. В случае недоступности выводит сообщение.
    *    
    * @method WebAccess.agent.checkAvailable
    * @return {boolean} True – Агент веб-доступа доступен для работы, иначе False.
    * @since 5.7.0
    */
    checkAvailability() {
      if (!this.isAvailable()) {        
        ShowInfo(L('AGENT_NEED_ENABLE_FOR_EXECUTE'));
        return false;
      }
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Проверяет, возможно ли использование Агента веб-доступа на данном устройстве.
     *
     * @method WebAccess.agent.canUseInCurrentDevice
     * @return {boolean} True – использование Агента веб-доступа возможно, иначе False.
     *
     * @example
     * if (WebAccess.agent.canUseInCurrentDevice()) {
     *  alert('Использование Агента веб-доступа на данном устройстве возможно.');
     * };
     */
    canUseInCurrentDevice: function () {
      var isARM = WA.ENV.ua.toLowerCase().search(/arm/) >= 0;
      var isBlackberry = WA.ENV.os.name === "BlackBerry";
      return !WA.ENV.isAndroid() && !WA.ENV.isIOS() && !isARM && !isBlackberry && !localStorage.getItem('autotest');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
     * Проверяет, что сессия Агента веб-доступа инициализирована.
     *
     * @method WebAccess.agent.isSessionInitialized
     * @return {boolean} True – сессия Агента веб-доступа инициализирована, иначе False.
     * @since 5.1.0.1511
     */
    isSessionInitialized: function () {
      return $.cookie('IsAgentSessionInitialized') === '1';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Устанавливает признак инициализации сессии Агента веб-доступа.
     *
     * @param {Boolean} value Устанавливаемое значение
     * @method WebAccess.agent.setSessionInitialized
     * @return {WebAccess.agent} Объект типа agent.
     * @since 5.1.0.1511
     */
    setSessionInitialized: function (value) {
      log.info('AGENT', 'Setting IsAgentSessionInitialized cookie with value: ' + value);
      $.cookie('IsAgentSessionInitialized', value ? '1' : '0');
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отображает состояние агента.
     *
     * @method WebAccess.agent._showState
     * @return {WebAccess.agent}
     * @since 5.1.0.1532
     * @private
     */
    _showState: function () {
      log.debug('AGENT', '------------ AGENT STATE --------------');
      log.debug('AGENT', 'web.config enabled: ' + g_IsAgentEnabled);
      log.debug('AGENT', 'isDisabled: ' + WA.agent.isDisabled());
      log.debug('AGENT', 'isSessionInitialized: ' + WA.agent.isSessionInitialized());
      log.debug('AGENT', '---------------- END -----------------');
    },

    /**
     * @override
     * @see agentCore.Agent.isPluginAvailable
     */
    isPluginAvailable: function (pluginName) {
      return this._super(pluginName, g_UserContextID);
    },

    /**
     * @override
     * @see agentCore.Agent.transmitRequest
     */
    transmitRequest: function (requestName, pluginName, params, extraParams) {
      return this._super(requestName, pluginName, params, g_UserContextID, extraParams);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Окно отображаемое при потере связи с агентом.
     *
     * @method WebAccess.agent._showWaitMoreDialog
     * @since 5.1.0.1511
     * @private
     * @return WebAccess.agent
     */
    _showWaitMoreDialog: function () {
      var me = this;

      if (!!me._showWaitMoreDialogTimeout) clearTimeout(me._showWaitMoreDialogTimeout);
      me._showWaitMoreDialogTimeout = setTimeout(function () {

        var isAgentStartedAfterWait = false;

        var cancelClickAndOnClose = function () {
          if (!isAgentStartedAfterWait) {
            WA.agent.disable();
            window.location.reload();
          }
        };

        var d = new WA.CMP.dialogs.MessageBox();
        d.id = 'waitMore';
        //d.isSingleInstance = true;
        d.width = 450;
        d.okCancelButtons(function okClick() {
          d.disableButton('modal_ok_button');
          d.inlineHint.showWarning(L('AGENT_WAITING_START'));
          $('#new_error_container').find('ui-icon').css({
            background: 'url("images/spinner.gif")',
          });

          global.WA.agent.transport.waitForStart(60000).done(function () {
            log.info('AGENT', 'Waiting for agent is done');
            // Всё же дождались старта.
            isAgentStartedAfterWait = true;
            d.close();
          }).fail(function (reason) {
            log.info('AGENT', 'Waiting for agent is failed');

            d.enableButton('modal_ok_button');
            // Не дождались.
            d.inlineHint.show(L('AGENT_WAITING_START_FAIL'));
          });

          return false;
        }, cancelClickAndOnClose);
        d.okText = L('WAIT_AGENT');
        d.cancelText = L('CONTINUE_WITHOUT_AGENT');
        d.show(L('AGENT_NOT_RESPONSE_WAIT_MORE'), L('AGENT_NOT_RESPONSE_WAIT_MORE_ADDITIONAL_TEXT'), L('ERROR'), 'error', null, cancelClickAndOnClose);

        log.info('AGENT', 'WaitMoreDialog was shown');

      }, 400);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _showWaitMoreDialogTimeout: null,

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Окно отображаемое при обращении к агенту в другой сессии ОС.
     *
     * @method WebAccess.agent._showAgentStartedInAnotherSessionDialog
     * @since 5.1.0.1511
     * @private
     */
    _showAgentStartedInAnotherSessionDialog: function () {
      var d = new WA.CMP.dialogs.MessageBox();
      d.id = 'anotherSessionError';
      d.isSingleInstance = true;
      d.okText = L('CONTINUE_WITHOUT_AGENT');
      d.show(L('AGENT_RUNNING_IN_AHOTHER_WINDOWS_SESSION'), L('AGENT_RUNNING_IN_AHOTHER_WINDOWS_SESSION_ADDITIONAL_TEXT'), L('ERROR'), 'error', null, function () {
        WA.agent.disable();
        window.location.reload();
      });
      log.info('AGENT', 'AgentStartedInAnotherSessionDialog was shown');
    },

    /**
     * @override
     * @see agentCore.Agent.start
     */
    start: function (opt_force) {
      return this._super(g_UserContextID);
    },

    /**
     * @override
     * @see agentCore.Agent.restart
     */
    restart: function () {
      return this._super(g_UserContextID);
    },

    /**
     * @override
     * @see agentCore.Agent.download
     */
    download: function (packageName) {
      var def = $.Deferred();

      if (!packageName) {
        var platform = WA.ENV.platform;
        var os = WA.ENV.os.name.toLowerCase();

        if (platform === 'linux') {
          if (os === 'mint' || os === 'ubuntu' || os === 'debian') {
            packageName = platform + '_deb';
          } else {
            packageName = platform + '_rpm';
          }
        } else {
          packageName = platform;
        }
      }

      if (g_AgentInstallID[packageName]) {
        window.open('/Download.ashx?accesstype=0&id=' + g_AgentInstallID[packageName]);
        def.resolve(packageName);
      } else {
        def.reject();
      }

      return def;
    },

    /**
     * @override
     * @see agentCore.Agent.checkSessionState
     */
    checkSessionState: function (attemptNumber) {
      return this._super(attemptNumber, g_UserContextID, this._showAgentStartedInAnotherSessionDialog);
    },

    /**
     * @override
     * @see agentCore.Agent.uploadLogs
     */
    uploadLogs: function () {
      var me = this;
      var d = $.Deferred();

      WA.SRV.callSync('/Security.asmx/GetOpToken0', { Operation: TOKEN_OPERATION.DIAGNOSTICS }).done((token) => {
        d = me._super(token, g_UserContextID);
      });

      return d.promise();
    },

    /**
     * @override
     * @see agentCore.Agent.keepAlive
     */
    keepAlive: function() {
      return this._super(g_UserContextID);
    },

    /**
     * @override
     * @see agentCore.Agent.beginSession
     */
    beginSession: function() {
      var me = this;
      var d = $.Deferred();
      WA.SRV.callSync('/Security.asmx/GetPermanentOpToken', { Operation: TOKEN_OPERATION.DIAGNOSTICS }).done((token) => {
        var params = {
          'UserLanguage': currentCultureName.split('-')[0],
          'UserName': g_User.Name,
          'SystemLanguage': appLang,
          'SessionID': g_UserContextID,
          'System': g_SysCode,
          'IsSecured': (document.location.protocol == 'http:' ? 'n' : 'y'),
          'Host': document.location.host,
          'WebLinkServer': g_WebServerName,
          'SessionUpdateTime': typeof SessionUpdateTime !== 'undefined' ? SessionUpdateTime : (10 * 60000),
          'MaxRequestLength': g_MaxJsonRequestLength,
          'NewJobsNotificationToken': '',
          'LogServiceToken': token,
          'ClientAffinity': $.cookie('ARRAffinity') || ''
        };

        me._super(params).done((result) => {
          d.resolve(result);
        }).fail((result) => {
          d.reject(result);
        });
      });

      
      return d.promise();
    },

    /**
     * @override
     * @see agentCore.Agent.endSession
     */
    endSession: function() {
      return this._super(g_UserContextID);
    },

    /**
     * @override
     * @see agentCore.Agent.setLanguage
     */
    setLanguage: function(language) {
      return this._super(language, g_UserContextID);
    }

  });

  global.WA.agent = new Agent();
  global.WA.agent.Agent = Agent;
  global.WA.agent.transport = global.agentCore.transport;
  $.when(global.WA.agent.transport.httpReady).then(function () {
    WA.AgentInit.resolve();
  });

})(window);
